import axios from "axios";
import { backendURL } from "../url";

const API_URL = "/api/website-popup";

export type WebsitePopup = {
  id: string;
  imageUrl: string | null;
  bannerText: string | null;
  bannerEnabled: boolean;
  createdAt: string;
  updatedAt: string;
};

export const getWebsitePopup = async (): Promise<WebsitePopup | null> => {
  const response = await axios.get(`${backendURL}${API_URL}`);
  return response.data.popup ?? null;
};

export const createWebsitePopup = async (file: File): Promise<WebsitePopup> => {
  const token = localStorage.getItem("token");
  const formData = new FormData();
  formData.append("image", file);

  const response = await axios.post(`${backendURL}${API_URL}`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data.popup;
};

export const updateWebsiteBanner = async (payload: {
  bannerText?: string | null;
  bannerEnabled?: boolean;
}): Promise<WebsitePopup> => {
  const token = localStorage.getItem("token");
  const response = await axios.put(`${backendURL}${API_URL}/banner`, payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.popup;
};

export const deleteWebsitePopup = async (): Promise<WebsitePopup | null> => {
  const token = localStorage.getItem("token");
  const response = await axios.delete(`${backendURL}${API_URL}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data.popup ?? null;
};
